// extracted by mini-css-extract-plugin
export default {"image":"FZ-z","loaded":"GZ-z"};